import Text from 'components/Text';
import { Card, Grid, IconButton, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { style } from 'constant/constants';
import EditIcon from '@mui/icons-material/Edit';
import TextEllipsize from 'utils/TextEllipsize';

const ProjectDetailsCard = ({ projectName, projectDescription, setAddOpenProjecModal }) => {
  return (
    <Card
      sx={{
        mb: 2,
        p: 1,
        mt: 2
      }}>
      <Grid display="flex" sx={{ alignItems: 'flex-start' }}>
        <Grid display="flex" direction="column" sx={{ mr: 2 }}>
          <Text
            variant="p"
            style={{ marginTop: '8px', color: style.LIGHT.primary, marginLeft: '2px' }}>
            <TextEllipsize value={projectName} length={70} />
          </Text>
          <Text
            variant="p"
            style={{ marginTop: '5px', color: style.LIGHT.primary, marginLeft: '2px' }}>
            <TextEllipsize value={projectDescription} length={70} />
          </Text>
        </Grid>
        <IconButton
          sx={{ pl: 1 }}
          onClick={() => {
            setAddOpenProjecModal(true);
            localStorage.setItem('isEditable', false);
          }}>
          <Tooltip title="Update">
            <EditIcon style={{ color: '#040273' }} />
          </Tooltip>
        </IconButton>
      </Grid>
    </Card>
  );
};

ProjectDetailsCard.propTypes = {
  projectName: PropTypes.string,
  projectDescription: PropTypes.string,
  setAddOpenProjecModal: PropTypes.func
};

export default ProjectDetailsCard;
